import { render, staticRenderFns } from "./buyerReference.vue?vue&type=template&id=72093822&"
import script from "./buyerReference.vue?vue&type=script&lang=js&"
export * from "./buyerReference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports